import { MessageBarType } from '@fluentui/react';

export const getMessageBarProps = (
  responseMessage: string
): {
  type: MessageBarType;
  message: string;
} => {
  const trimmedMessage = responseMessage.trim();
  const match = trimmedMessage.match(/^(Success|Info|Error):\s*(.*)/i);

  if (!match) {
    return { type: MessageBarType.warning, message: responseMessage };
  }

  const [, prefix, messageBody] = match;

  switch (prefix.toLowerCase()) {
    case 'success':
      return { type: MessageBarType.success, message: messageBody };
    case 'info':
      return { type: MessageBarType.warning, message: messageBody };
    case 'error':
      return { type: MessageBarType.error, message: messageBody };
    default:
      return { type: MessageBarType.warning, message: responseMessage };
  }
};

export interface ParsedResponseMessages {
  added: string[];
  duplicates: string[];
  invalid: string[];
}

export const parseResponseMessage = (responseMessage: string): ParsedResponseMessages | null => {
  const trimmedMessage = responseMessage.trim();

  // Extract the arrays from the message
  // Format: "Info: Successfully added X new items. Added: [array]. Duplicates ignored: [array]. Invalid ignored: [array]."
  const addedMatch = trimmedMessage.match(/Added:\s*\[([^\]]*)\]/);
  const duplicatesMatch = trimmedMessage.match(/Duplicates ignored:\s*\[([^\]]*)\]/);
  const invalidMatch = trimmedMessage.match(/Invalid ignored:\s*\[([^\]]*)\]/);

  // If we can't parse the message format, return null
  if (!addedMatch && !duplicatesMatch && !invalidMatch) {
    return null;
  }

  const parseArray = (match: RegExpMatchArray | null): string[] => {
    if (!match || !match[1] || match[1].trim() === '') {
      return [];
    }
    return match[1]
      .split(',')
      .map((item) => item.trim())
      .filter((item) => item !== '');
  };

  return {
    added: parseArray(addedMatch),
    duplicates: parseArray(duplicatesMatch),
    invalid: parseArray(invalidMatch),
  };
};
